import { HandCoins } from "@phosphor-icons/react";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { DealsSummarySection } from "../components/shared/DealsSummarySection";

const navItems = [{ to: "/admin/deals-summary", label: "Deals Summary", icon: <HandCoins size={18} weight="duotone" />, testId: "nav-admin-deals-summary" }];

export default function AdminDealsSummaryPage() {
  return (
    <DashboardLayout navItems={navItems} moduleName="Deals Summary" moduleBackPath="/admin">
      <div data-testid="admin-deals-summary-page">
        <DealsSummarySection apiBase="/admin" />
      </div>
    </DashboardLayout>
  );
}
